import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { LeverageTokenInfoSummaryModule } from "./leverage-token-info-summary/leverage-token-info-summary.module";
import { LeveragedTokenToggleModule } from "./leveraged-token-toggle/leveraged-token-toggle.module";
import { LeveragedTokenInfoAmountModule } from "@modules/main/components/leveraged-tokens/amount-select-leveraged-info/leveraged-token-info-amount.module";
import { LeverageTokenCheckoutSummaryModule } from "@modules/main/components/leveraged-tokens/leveraged-token-checkout-summary/leverage-token-checkout-summary.module";

const MODULES = [
	LeveragedTokenToggleModule,
	LeverageTokenInfoSummaryModule,
	LeveragedTokenInfoAmountModule,
	LeverageTokenCheckoutSummaryModule
];

@NgModule({
	imports: [CoreModule, ...MODULES],
	exports: [...MODULES]
})
export class LeveragedTokensModule {}
